export const ROUTES = {
  HOME: {
    path: '/',
    name: 'Home'
  },
  DEALER: {
    path: '/dealer',
    name: 'Dealer'
  },
  PERSONAL: {
    ROOT: {
      path: '/personal',
      name: 'Personal'
    },
    YOUR_DETAILS: {
      path: '/personal/your-details',
      name: 'Your details'
    },
    ABOUT_YOU: {
      path: '/personal/about-you',
      name: 'About you'
    },
    INCOME: {
      path: '/personal/income',
      name: 'Income details'
    },
    FINANCIAL_POSITION: {
      path: '/personal/financial-position',
      name: 'Financial position'
    },
    DOC_UPLOAD: {
      path: '/personal/doc-upload',
      name: 'Application options'
    },
    END_APPLICATION: {
      path: '/personal/end-application',
      name: 'End application'
    }
  },
  BUSINESS: {
    ROOT: {
      path: '/business',
      name: 'Business'
    },
    ABOUT_YOUR_BUSINESS: {
      path: '/business/about-your-business',
      name: 'About your business'
    },
    ABOUT_YOU: {
      path: '/business/about-you',
      name: 'About you'
    },
    FINANCIAL_POSITION: {
      path: '/business/financial-position',
      name: 'Financial position'
    },
    APPLICATION_OPTIONS: {
      path: '/business/application-options',
      name: 'Application options'
    },
    END_APPLICATION: {
      path: '/business/end-application',
      name: 'End application'
    }
  }
}
